import React from 'react';
import './SubscriptionDetails.css';
import { FaCheckCircle, FaCalendarAlt, FaEnvelope, FaPhone, FaTools } from 'react-icons/fa'; // Importing tick mark and other icons
import PriceCalculator from './PriceCalculator';


const PricingHeaderComponent = ({account,  logged_in, user}) => {

  return (
    <div className='sub-details'>
      <h3 className='sub-title'>Pricing Details</h3>
      <p className='sub-title' style={{color:'var(--clr-grey-3)', fontSize:'1.5rem'}}>Tailored pricing to match the unique needs of your practice.</p>

      {/* Pricing Cards Section */}
      <div className='sub-pricing-container'>
        {/* Silver Plan Card */}
        <div className='sub-pricing-card'>
          <div className='plan-header' style={{display:'block'}}>
            <h4>Silver Plan</h4>
          </div>
          <p style={{ color: 'var(--clr-primary-1)' }}><strong>CAD $54/month</strong></p>
          <section>
            <h5><FaCalendarAlt className="icon" /> Scheduling:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Up to 20 appointments per month</li>
              <li><FaCheckCircle className="tick-icon" /> In-Person 1:1 Appointments</li>
              <li><FaCheckCircle className="tick-icon" /> Group Appointments</li>
            </ul>
          </section>
          <section>
            <h5><FaEnvelope className="icon" /> Patient Communication:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Email Appointment Reminders</li>
              <li><FaCheckCircle className="tick-icon" /> Secure Patient Portal</li>
            </ul>
          </section>
          <section>
            <h5><FaPhone className="icon" /> Support:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Email and Phone Support</li>
              <li><FaCheckCircle className="tick-icon" /> Free Data Import</li>
            </ul>
          </section>
          <div className="sub-card-buttons">
            {/* <button className='sub-btn-card'>Sign Up</button> */}
            <button className='sub-btn-card sub-demo-btn'>Book a Demo</button>
          </div>
        </div>

        {/* Gold Plan Card */}
        <div className='sub-pricing-card'>
          <div className='plan-header' style={{display:'block'}}>
            <h4>Gold Plan</h4>
          </div>
          <p style={{ color: 'var(--clr-primary-1)' }}><strong>CAD $79/month</strong></p>
          <section>
            <h5><FaCalendarAlt className="icon" /> Scheduling:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Unlimited Appointments</li>
              <li><FaCheckCircle className="tick-icon" /> Group Appointments</li>
              <li><FaCheckCircle className="tick-icon" /> Classes</li>
            </ul>
          </section>
          <section>
            <h5><FaEnvelope className="icon" /> Patient Communication:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Unlimited Email Reminders</li>
              <li><FaCheckCircle className="tick-icon" /> SMS Appointment Reminders</li>
            </ul>
          </section>
          <section>
            <h5><FaPhone className="icon" /> Support:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> 24/7 Chat, Email, and Phone Support</li>
            </ul>
          </section>
          <div className="sub-card-buttons">
            {/* <button className='sub-btn-card'>Sign Up</button> */}
            <button className='sub-btn-card sub-demo-btn'>Book a Demo</button>
          </div>
        </div>

        {/* Platinum Plan Card */}
        <div className='sub-pricing-card'>
          <div className='plan-header' style={{display:'block'}}>
            <h4>Platinum Plan</h4>
          </div>
          <p style={{ color: 'var(--clr-primary-1)' }}><strong>CAD $99/month</strong></p>
          <section>
            <h5><FaCalendarAlt className="icon" /> Scheduling:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Advanced Scheduling</li>
              <li><FaCheckCircle className="tick-icon" /> Rooms & Equipment</li>
              <li><FaCheckCircle className="tick-icon" /> Automated Patient Waitlist</li>
            </ul>
          </section>
          <section>
            <h5><FaTools className="icon" /> Marketing Tools:</h5>
            <ul>
              <li><FaCheckCircle className="tick-icon" /> Ratings and Reviews</li>
              <li><FaCheckCircle className="tick-icon" /> Google Analytics Integration</li>
            </ul>
          </section>
          <div className="sub-card-buttons">
            {/* <button className='sub-btn-card'>Sign Up</button> */}
            <button className='sub-btn-card sub-demo-btn'>Book a Demo</button>
          </div>
        </div>
      </div>

      
      <hr className="section-divider" />
       {/* Add the Price Calculator */}
       <PriceCalculator />

       <hr className="section-divider" />
      {/* Plan Comparison Component */}
      <PlanComparison />
    </div>
  );
};

/* Plan Comparison Component */
const PlanComparison = () => {
  return (
    <div className="comparison-container">
      <h3 className="comparison-title">Plan Comparison</h3>
      
  
      {/* Feature Comparison */}
      <div className="comparison-grid">
        {/* Feature Row */}
        <div className="feature-row">
          <div className="feature-name">Appointments</div>
          <div className="feature-value">Up to 20</div>
          <div className="feature-value">Unlimited</div>
          <div className="feature-value">Unlimited</div>
        </div>
        <div className="feature-row">
          <div className="feature-name">Admin Access</div>
          <div className="feature-value">Limited</div>
          <div className="feature-value">Unlimited</div>
          <div className="feature-value">Unlimited</div>
        </div>
        <div className="feature-row">
          <div className="feature-name">Patient Portal</div>
          <div className="feature-value">Basic</div>
          <div className="feature-value">Advanced</div>
          <div className="feature-value">Premium</div>
        </div>
        <div className="feature-row">
          <div className="feature-name">Custom Branding</div>
          <div className="feature-value">No</div>
          <div className="feature-value">Yes</div>
          <div className="feature-value">Yes</div>
        </div>
      </div>
    </div>

  );
};

export default PricingHeaderComponent;
